<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择打印机"
      top="5vh"
      width="1100px">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="printerModules"
        @select="selectPrinterModule"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="组件编号">
            <el-input v-model.trim="filter.no" placeholder="请输入组件编号" clearable/>
          </el-form-item>
          <el-form-item label="组件名称">
            <el-input v-model.trim="filter.name" placeholder="请输入组件名称" clearable/>
          </el-form-item>
          <el-form-item label="模板路径">
            <el-input v-model.trim="filter.url" placeholder="请输入模板路径" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          no: "",
          name: "",
          status: 0,
        },
        columns: [
          {
            title: "组件编号",
            key: "no",
            width: 240,
          },
          {
            title: "组件名称",
            key: "name",
            align: "center",
          },
          {
            title: "模板路径",
            key: "url",
            align: "center",
            width: 240,
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        // 清空查询条件
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      // 选择组件
      selectPrinterModule(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
